"use client";

import { useState } from "react";
import ReadMore from "@/app/(main)/components/ReadMore";

interface TabItem {
  key: string;
  label: string;
  icon: string;
  content: string;
}

export default function ShipDetailsTabs({ tabs }: { tabs: TabItem[] }) {
  const [activeTab, setActiveTab] = useState(tabs[0]?.key ?? "");

  if (!tabs.length) return null;

  return (
    <div className="mt-40">
      {/* ── Tab Navigation ── */}
      <div className="d-flex flex-wrap gap-2 justify-content-start">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className="ship-tab-btn"
              data-active={isActive ? "true" : "false"}
            >
              <i className={`${tab.icon} me-2`}></i>
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* ── Tab Content ── */}
      <div className="mt-30">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            style={{
              display: activeTab === tab.key ? "block" : "none",
              animation:
                activeTab === tab.key ? "shipTabFadeIn 0.35s ease" : "none",
            }}
          >
            {tab.key === "description" ? (
              <ReadMore html={tab.content} limit={600} />
            ) : (
              <div
                className="blog-text theme__html checklist cruise-tab-content"
                dangerouslySetInnerHTML={{ __html: tab.content }}
              />
            )}
          </div>
        ))}
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes shipTabFadeIn {
              from { opacity: 0; transform: translateY(6px); }
              to { opacity: 1; transform: translateY(0); }
            }

            .ship-tab-btn {
              display: inline-flex;
              align-items: center;
              padding: 10px 22px;
              font-size: 14px;
              font-weight: 600;
              border-radius: 6px;
              border: 2px solid #e5e7eb;
              background: #fff;
              color: #555;
              cursor: pointer;
              transition: all 0.2s ease;
            }
            .ship-tab-btn:hover {
              border-color: var(--theme-color, #e8604c);
              color: var(--theme-color, #e8604c);
              background: #fff;
            }
            .ship-tab-btn[data-active="true"] {
              background: var(--theme-color, #e8604c);
              color: #fff;
              border-color: var(--theme-color, #e8604c);
            }
            .ship-tab-btn[data-active="true"]:hover {
              background: var(--theme-color, #e8604c);
              color: #fff;
              border-color: var(--theme-color, #e8604c);
              opacity: 0.9;
            }

            .cruise-tab-content {
              line-height: 1.8;
            }
            .cruise-tab-content p {
              margin-bottom: 1rem;
            }
            .cruise-tab-content img {
              max-width: 100%;
              height: auto;
              border-radius: 8px;
              margin: 12px 0;
            }
            .cruise-tab-content ul,
            .cruise-tab-content ol {
              padding-left: 1.5rem;
              margin-bottom: 1rem;
            }
            .cruise-tab-content li {
              margin-bottom: 0.35rem;
            }
            .cruise-tab-content table {
              width: 100%;
              border-collapse: collapse;
              margin: 1rem 0;
            }
            .cruise-tab-content table th,
            .cruise-tab-content table td {
              border: 1px solid #e5e7eb;
              padding: 10px 14px;
              text-align: left;
            }
            .cruise-tab-content table th {
              background: #f8f9fa;
              font-weight: 600;
            }
          `,
        }}
      />
    </div>
  );
}
